import { DialogType } from '@tableau/widgets';
import React = require('react');
import { Set } from '~commonInfra/utils/Set';

import { ModalInstance, ReactModalService } from '../../../../commonInfra/dialogs/ReactModalService';
import { UpdateGrantLicenseModeDialog } from '../../components/UpdateGrantLicenseModeDialog';
import { IGroupInfo } from '../../models/IGroupInfo';

const groupUpdateDialogStyle: React.CSSProperties = {
  width: 'auto',
  height: 'auto',
  paddingTop: '18px',
  paddingBottom: '12px',
  paddingLeft: '12px',
  paddingRight: '12px'
};

function showUpdateGrantLicenseModeDialog(groupsToSet: Set<IGroupInfo>): Promise<any> {
  let modalInstance: ModalInstance;
  const dialogProps = {
    dismiss: () => modalInstance && modalInstance.dismiss('cancel'),
    close: (result: any) => modalInstance && modalInstance.close(result),
    groupsToSet: groupsToSet,
    isActiveDirectory: false
  };

  modalInstance = ReactModalService.open({
    type: DialogType.Uber,
    dialogContent: React.createElement(UpdateGrantLicenseModeDialog, dialogProps),
    testId: 'updateLocalGroupGrantLicenseMode',
    showCloseButton: true,
    dialogStyle: groupUpdateDialogStyle,
    dialogBodyStyle: {overflow: 'hidden'},
    shouldNotSetDefaultWidth: false
  });

  return Promise.resolve(modalInstance.result);
}

export const UpdateLocalGroupGrantLicenseModeAction = {
  showUpdateGrantLicenseModeDialog
};
